import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { AppWizardService } from '../../../services/app-wizard.service';
import { WizardStepperService } from '../../../services/wizard-stepper.service';
import { WizardStep } from '../../../models/app-wizard-state';

enum StepStatus {
	WIP = 0,
	WAIT = 1,
	DONE = 2
}

interface StepDetail {
	num: number;
	labelTransId: string;
	status: StepStatus;
}

@Component({
	selector: 'copo-offer-wizard-stepper',
	templateUrl: './wizard-stepper.component.html',
	styleUrl: './wizard-stepper.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgFor, NgIf, MatRippleModule, MatIconModule, TranslateModule, MatButtonModule]
})
export class WizardStepperComponent implements OnDestroy {
	@Input() currentStep = 0;

	readonly WIP = StepStatus.WIP;
	readonly WAIT = StepStatus.WAIT;
	readonly DONE = StepStatus.DONE;

	steps: StepDetail[] = [
		{
			num: 0,
			labelTransId: 'offers.wizard.stepper.request.and.selection',
			status: StepStatus.WIP
		},
		{
			num: 1,
			labelTransId: 'offers.wizard.stepper.customization',
			status: StepStatus.WAIT
		},
		{
			num: 2,
			labelTransId: 'offers.wizard.stepper.step.quantity',
			status: StepStatus.WAIT
		},
		{
			num: 3,
			labelTransId: 'offers.wizard.stepper.step.offer-summary',
			status: StepStatus.WAIT
		}
	];

	private readonly stepChangeSupscription: Subscription;

	constructor(
		private readonly stepperService: WizardStepperService,
		private readonly appWizardService: AppWizardService
	) {
		this.stepChangeSupscription = this.stepperService.onStepChanged.subscribe({
			next: (result: { step: number }) => {
				this.currentStep = result.step;
				this.rearengeSteps();
			}
		});
	}

	ngOnDestroy() {
		this.stepChangeSupscription.unsubscribe();
	}

	nextStep() {
		this.currentStep += 1;
		this.rearengeSteps();
	}

	isSummaryStep() {
		return this.appWizardService.getState().stepIndex === WizardStep.REVIEW;
	}

	print() {
		print();
	}

	async onStepClick(stepClick: number) {
		await this.appWizardService.actionMoveUsingSteps(stepClick);
	}

	private rearengeSteps() {
		this.processCurrentStep();
		this.processPreviousStep();
		this.processLeftSteps();
	}

	private processCurrentStep() {
		const currentStep = this.steps[this.currentStep];
		currentStep.status = StepStatus.WIP;
		this.steps[this.currentStep] = currentStep;
	}

	private processPreviousStep() {
		if (this.currentStep <= 0) {
			return;
		}
		for (let i = this.currentStep - 1; i >= 0; i--) {
			const previousStep = this.steps[i];
			previousStep.status = StepStatus.DONE;
			this.steps[i] = previousStep;
		}
	}

	private processLeftSteps() {
		if (this.currentStep === this.steps.length - 1) {
			return;
		}
		for (let i = this.currentStep + 1; i < this.steps.length; i++) {
			const leftStep = this.steps[i];
			leftStep.status = StepStatus.WAIT;
			this.steps[i] = leftStep;
		}
	}
}
